import React from 'react';

import { observer } from 'mobx-react';
import { clientStore } from 'apps/client/app';
import { withNamespaces } from 'react-i18next';
import { refreshAccessToken } from 'core/jwt';

import { Countdown } from '../Countdown';

const ExitBanner = () => {
  const countDownSecondsCache = clientStore.getCountdownSeconds();
  const initialSeconds = countDownSecondsCache
    ? Number(countDownSecondsCache)
    : 600;

  const handleStopImpersonation = async () => {
    await refreshAccessToken(clientStore);

    clientStore.clearImpersonationSession();
    clientStore.clearCountdownSeconds();

    window.location.replace('/');
  };

  const handleCountdownTick = (seconds: number) => {
    clientStore.setCountdownSeconds(seconds);
  };

  return (
    <div className='bg-black text-white fixed mt-1 text-16 w-fit left-1/2 -translate-x-1/2'>
      <span>
        Impersonating as user {'  '}
        <span className='text-red-500'>
          {clientStore.signedInProfile.username}
        </span>
        <span className='ml-1'>.</span>
        <span className='ml-4 mr-2'>This session will be closed after</span>
        <Countdown
          initialSeconds={initialSeconds}
          onCountdownEnd={handleStopImpersonation}
          onCountdownTick={handleCountdownTick}
        />
        <span>
          <span className='mx-2'>or</span>
          <span
            className='text-red-500 cursor-pointer'
            onClick={handleStopImpersonation}
          >
            Exit
          </span>
        </span>
      </span>
    </div>
  );
};

export default withNamespaces()(observer(ExitBanner));
